import axios from "axios";
import { getToken } from "../../Utlis/UpdateUserState";

const getDrivers = async () => {
  try {
    const token = getToken();

    const res = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}fleet-manager/drivers/`,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Drivers fetch error:", error);
    throw error;
  }
};

const getDriverById = async (id) => {
  try {
    const token = getToken();

    const res = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}fleet-manager/drivers/?id=${id}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Driver fetch error:", error);
    throw error;
  }
};

const getDriversLookup = async (vehicleId) => {
  try {
    const token = getToken();

    const res = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}fleet-manager/drivers/lookup`,
      {
        headers: { Authorization: `Bearer ${token}` },
        params: vehicleId ? { vehicle_id: vehicleId } : undefined,
      },
    );

    return res;
  } catch (error) {
    console.error("Drivers lookup fetch error:", error);
    throw error;
  }
};

const updateDriver = async (id, data) => {
  try {
    const token = getToken();

    const res = await axios.patch(
      `${process.env.REACT_APP_BACKEND_URL}fleet-manager/drivers/?id=${id}`,
      data,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Driver update error:", error);
    throw error;
  }
};

const updateDriverStatus = async (id, data) => {
  try {
    const token = getToken();

    const res = await axios.patch(
      `${process.env.REACT_APP_BACKEND_URL}fleet-manager/drivers/status/?id=${id}`,
      data,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Driver status update error:", error);
    throw error;
  }
};

const createDriver = async (data) => {
  try {
    const token = getToken();

    const res = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}fleet-manager/drivers/`,
      data,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Driver create error:", error);
    throw error;
  }
};

const getDriverDocumentTypes = async () => {
  try {
    const token = getToken();

    const res = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}fleet-manager/drivers/document-types/`,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Driver document types fetch error:", error);
    throw error;
  }
};

const deleteDriverDocument = async (documentId) => {
  try {
    const token = getToken();

    const res = await axios.delete(
      `${process.env.REACT_APP_BACKEND_URL}documents/?id=${documentId}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Driver document delete error:", error);
    throw error;
  }
};

export {
  getDrivers,
  getDriverById,
  getDriversLookup,
  updateDriver,
  updateDriverStatus,
  createDriver,
  getDriverDocumentTypes,
  deleteDriverDocument,
};
